import { Toast } from 'antd-mobile';

const ToastShow = {
  // 成功提示
  info: (content: string, duration?: number) => {
    Toast.show({
      content: (
        <div style={{
          backgroundColor: '#000',
          color: 'white',
          padding: '10px 5px',
          borderRadius: '12px',
          fontSize: '16px',
          fontWeight: '500',
        }}>
          {content}
        </div>
      ),
      duration,
    });
  },

  specialInfo: (content: string, duration?: number) => {
    Toast.show({
      content: (
        <div style={{
          backgroundColor: 'white',
          color: '#000',
          padding: '10px 5px',
          borderRadius: '12px',
          fontSize: '16px',
          fontWeight: '500',
        }}>
          {content}
        </div>
      ),
      duration,
    });

  }
};

export default ToastShow;